import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Row, Col } from "reactstrap";
import TruncatedText from "Components/Common/TruncatedText";

interface ViewActivitiesModalProps {
  isOpen: boolean;
  onClose: () => void;
  activities: any[];
}

const ViewActivitiesModal: React.FC<ViewActivitiesModalProps> = ({
  isOpen,
  onClose,
  activities
}) => {
  return (
    <Modal
      isOpen={isOpen}
      toggle={onClose}
      size="lg"
      backdrop="static"
      className="common_modal"
      centered
    >
      <ModalHeader toggle={onClose} className="fw-bold border-bottom p-3">
        <div className="d-flex align-items-center gap-2">
          <div style={{
            width: 36, height: 36, borderRadius: 10, background: "#eff6ff",
            display: "flex", alignItems: "center", justifyContent: "center", border: "1px solid #bfdbfe"
          }}>
            <i className="ri-list-check-2 text-primary fs-18" />
          </div>
          <div>
            <h5 className="mt-3 modal-title mb-0 fw-bold">All Visit Activities</h5>
            <span className="text-muted" style={{ fontSize: 12 }}>
              Protocol tasks scheduled for this visit ({activities.length} Activities)
            </span>
          </div>
        </div>
      </ModalHeader>
      <ModalBody style={{ maxHeight: "60vh", overflowY: "auto" }}>
        <Row className="g-3">
          {activities.map((act: any, idx: number) => {
            const catLabel = act.activitycategoryname || "Activity";

            return (
              <Col md={6} key={idx}>
                <div
                  style={{
                    border: "1px solid #e2e8f0",
                    borderRadius: "16px",
                    padding: "16px",
                    background: "#ffffff",
                    boxShadow: "0 1px 3px rgba(0,0,0,0.02)",
                    transition: "all 0.2s ease-in-out",
                    cursor: "pointer",
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between"
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "translateY(-3px)";
                    e.currentTarget.style.boxShadow = "0 10px 15px -3px rgba(0, 0, 0, 0.05), 0 4px 6px -2px rgba(0, 0, 0, 0.05)";
                    e.currentTarget.style.borderColor = "#cbd5e1";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "translateY(0)";
                    e.currentTarget.style.boxShadow = "0 1px 3px rgba(0,0,0,0.02)";
                    e.currentTarget.style.borderColor = "#e2e8f0";
                  }}
                >
                  <div>
                    <div className="d-flex align-items-start gap-3">
                      {/* Main Icon (left) */}
                      <div style={{
                        width: "46px",
                        height: "46px",
                        borderRadius: "12px",
                        background: "#eff6ff",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexShrink: 0
                      }}>
                        <i className="ri-file-text-line text-primary" style={{ fontSize: "20px" }} />
                      </div>

                      {/* Content (middle) */}
                      <div className="flex-grow-1">
                        <div style={{ fontWeight: 700, fontSize: "11px", color: "#2563eb", textTransform: "uppercase", letterSpacing: "0.08em" }}>
                          {catLabel}
                        </div>
                        <h5 className="fw-bold mb-0 text-dark mt-1" style={{ fontSize: "16px", color: "#1e293b", letterSpacing: "-0.01em" }}>
                          <TruncatedText text={act.activityname || "--"} maxWidth="220px" />
                        </h5>
                      </div>

                      {/* Right chevron indicator */}
                      <div style={{ alignSelf: "center", color: "#94a3b8" }}>
                        <i className="ri-chevron-right-line fs-18" />
                      </div>
                    </div>
                  </div>

                  <div>
                    {/* Dashed divider */}
                    <div style={{ borderTop: "1px dashed #e2e8f0", margin: "14px 0" }} />

                    {/* Bottom row */}
                    <div className="d-flex justify-content-between align-items-center">
                      {/* Left: Clock Icon & Estimated Time pill */}
                      <div style={{
                        background: "#f0fdf4",
                        borderRadius: "8px",
                        padding: "6px 12px",
                        display: "flex",
                        alignItems: "center",
                        gap: "8px"
                      }}>
                        <i className="ri-time-line text-success" style={{ fontSize: "16px" }} />
                        <div className="d-flex flex-column" style={{ lineHeight: "1.2" }}>
                          <span style={{ fontSize: "9px", color: "#475569", fontWeight: 500, textTransform: "uppercase" }}>
                            Estimated Time
                          </span>
                          <span style={{ fontSize: "12px", fontWeight: 700, color: "#15803d" }}>
                            {act.estimateddurationminutes || 10} {(act.estimateddurationminutes || 10) === 1 ? "Min" : "Mins"}
                          </span>
                        </div>
                      </div>
                      <div>
                        {act.ismandatory ? (
                          <span style={{
                            background: "#fef2f2",
                            color: "#ef4444",
                            border: "1px solid #fee2e2",
                            padding: "6px 12px",
                            borderRadius: "50px",
                            fontSize: "11px",
                            fontWeight: 700,
                            display: "inline-flex",
                            alignItems: "center",
                            gap: "4px"
                          }}>
                            <i className="ri-shield-check-line" /> Mandatory
                          </span>
                        ) : (
                          <span style={{
                            background: "#f8fafc",
                            color: "#64748b",
                            border: "1px solid #e2e8f0",
                            padding: "6px 12px",
                            borderRadius: "50px",
                            fontSize: "11px",
                            fontWeight: 700,
                            display: "inline-flex",
                            alignItems: "center",
                            gap: "4px"
                          }}>
                            <i className="ri-checkbox-blank-circle-line" /> Optional
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
            );
          })}
        </Row>
      </ModalBody>
      <ModalFooter className="bg-white border-top">
        <Button color="dark" outline onClick={onClose}>Close</Button>
      </ModalFooter>
    </Modal>
  );
};

export default ViewActivitiesModal;
